import { motion } from 'framer-motion';
import styles from '../Settings.module.css';

export interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
}

export function ToggleSwitch({ checked, onChange, label }: ToggleSwitchProps) {
  return (
    <motion.button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      className={styles.toggle}
      onClick={() => onChange(!checked)}
      whileTap={{ scale: 0.95 }}
    >
      <span className={styles.toggleKnob} />
    </motion.button>
  );
}
